











































import {Vue, Component, Prop} from 'vue-property-decorator';

@Component
export default class HistoryLayer extends Vue {
  @Prop() private showFlg!: boolean;
  private closePop() {
    this.$emit('update:showFlg', false);
  }

  @Prop() private items!: any;
  private showItems: any = [];

  private async created() {
    this.showItems = this.items
      .map(item => {
        let displayStatusLabel = item.reason === this.$t('COMMON_DELETE') ? this.$t('COMMON_DELETE') : item.displayStatusLabel;
        let bestReviewLabel = item.isBestReview ? this.$t('PRODUCT_REVIEW_REVIEW_TYPE_BEST') : this.$t('PRODUCT_REVIEW_REVIEW_TYPE_NORMAL');
        let registerName = item.isAdmin ? item.registerName : this.$t('PRODUCT_REVIEW_REGISTER_NAME');
        return {
          registerDateTime: item.registerDateTime,
          displayStatusLabel,
          bestReviewLabel,
          registerName,
          reason: item.reason
        };
      })
      .sort((itemA, itemB) => (itemA.registerDateTime > itemB.registerDateTime ? -1 : 1));
  }
  private mounted() {
    $('body').addClass('no-scroll');
  }
  beforeDestroy() {
    $('body').removeClass('no-scroll');
  }
}
